import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { getConfig } from '@/request/common';

export default createStore({
	state: {
		/**
		 * @name 角色号
		 * @param {string}
		 * @default null
		 */
		role: '2',
		/**
		 * @name 用户账号
		 * @param {string}
		 * @default null
		 */
		userId: '',
		/**
		 * @name 用户名
		 * @param {string}
		 * @default null
		 */
		userName:'',
		/**
		 * @name 菜单选中的值
		 * @param {string}
		 * @default null
		 */
		menuSelectId: 14,
		/**
		 * @name 3D模拟显示信号
		 * @param {boolean}
		 * @default false
		 */
		threeDShow: false,
		/**
		 * @name 是否使用右上角飞机/汽车小角标
		 * @param {['plane', 'car'] | ['plane'] | ['car'] | [] | null}
		 * @default false
		 */
		planeAndCarUse: ['plane', 'car'],
		/**
		 * @method 菜单栏的权限数据
		 * @param {any} 数据
		 */
		menuStatus: null,
		/**
		 * @method 刷新菜单栏的权限数据方法
		 * @param {function} 方法
		 */
		menuStatusRefresh: function () {},
		/**
		 * @method 公共配置信息
		 * @param {any} 数据
		 */
		configData: null,
		lang: 'zh'
	},
	getters: {},
	mutations: {
		/**
		 * @method 设置用户账号
		 * @param {any} state
		 * @param {string} id ID
		 */
		updateUserId(state, id) {
			state.userId = id;
		},
		/**
		 * @method 设置用户角色
		 * @param {any} state
		 * @param {number | string} role
		 */
		updateUserRole(state, role) {
			state.role = role;
		},
		/**
		 * @method 设置菜单选中的值
		 * @param {any} state
		 * @param {any} menuSelectId 菜单ID
		 */
		updateMenuSelectId(state, menuSelectId) {
			state.menuSelectId = menuSelectId;
		},
		/**
		 * @method 设置菜单选中的值-手动点击的时候带检验
		 * @param {any} state
		 * @param {any} menuSelectId 菜单ID
		 */
		updateMenuSelectIdClick(state, menuSelectId) {
			// const status = state.menuStatus?.data.find((val) => val.id === menuSelectId)?.Status;
			// if (!status) return;
			state.menuSelectId = menuSelectId;
		},
		/**
		 * @method 3D模拟显示信号更改
		 * @param {any} state
		 * @param {boolean} sign 信号
		 */
		updateThreeDShow(state, sign = null) {
			if (sign === null) state.threeDShow = !state.threeDShow;
			if (sign !== null) state.threeDShow = sign;
		},
		/**
		 * @name 是否使用右上角飞机/汽车小角标更改
		 * @param {any} state
		 * @param {['plane', 'car'] | ['plane'] | ['car'] | [] | null} type 类型
		 */
		updatePlaneAndCarUse(state, type = null) {
			if (Object.prototype.toString.call(type) === '[object Array]' && type.length) state.planeAndCarUse = type;
			else state.planeAndCarUse = [];
		},
		/**
		 * @method 刷新菜单栏的权限数据方法
		 * @param {function} fun 方法
		 */
		setMenuStatusRefresh(state, fun) {
			state.menuStatusRefresh = fun;
		},
		/**
		 * @name 菜单栏的权限数据更改
		 * @param {any} data 数据
		 */
		updateMenuStatus(state, data) {
			state.menuStatus = data;
		},
		/**
		 * @name 公共配置更改
		 * @param {any} data 数据
		 */
		updateConfigData(state, data) {
			state.configData = data;
		},
		/**
		 * @name 公共配置更改
		 * @param {any} data 数据
		 */
		updateuserName(state, data) {
			state.userName = data;
		},
		/**
		 * @name 重置数据
		*/
		reserdata(state){
			state.role = null;
			state.userId = null;
			state.userName = null;
			state.menuSelectId = null;
			state.threeDShow = false;
			state.menuStatus = null;
			state.planeAndCarUse = [];
			state.configData = null;
		},
		updateLang(state, data) {
			state.lang = data
		}
	},
	actions: {
		/**
		 * @method 异步获取公共配置
		 * @param {any} content 实例对象
		 */
		updateConfigDataAsync(content) {
			getConfig().then((data) => {
				content.commit('updateConfigData', data);
			});
		},
		/**
		 * @method 初始化基本点
		 * @param {any} maskdata 标点数据
		 */
		initSdMarks(maskdata){
			// 更新标点
			let allOverlay = mapobj.value.getOverlays();
			allOverlay.forEach((item, index) => {
			  if (item instanceof BMap.Marker || item instanceof BMap.Circle) {
				mapobj.value.removeOverlay(item);
			  }
			});
			  // 坐标字符串数组化
			  maskdata.forEach((ite,inde)=>{
				ite.Coordinate = ite.Coordinate.split(",")
			  })
			maskdata.map(function (item, index) {
			  let point = new BMap.Point(item.Coordinate[0], item.Coordinate[1]);
			  let m;
			  let iconsrc
			  if(item.MainId == 0){
				iconsrc = require("../assets/images/map/warehouse2.png")
			  }else{
				iconsrc = require("../assets/images/map/location2.png")
			  }
			  m = new BMap.Marker(point,{icon:new BMap.Icon(iconsrc,new BMap.Size(24,24))});
			  m.disaster = false;
			  m.name = item.DisasterName;
			  m.distype = item.DisasterType;
			  m.id = item.MainId;
			  m.level = item.RiskLevel;
			  m.addEventListener("click", getPointPosition);
			  mapobj.value.addOverlay(m);
			  if(item.People != undefined && item.People != 0) {
				let cr = item.People * 10
				let circle = new BMap.Circle(point, cr, {
				strokeColor: "#a8b7f4",
				strokeWeight: 1,
				fillColor:"#a8b7f4",    
			  });
			  mapobj.value.addOverlay(circle);
			  }   
			});
			allPoint.value = maskdata;
		  }
	},
	modules: {},
	plugins: [
		createPersistedState({
			storage: window.sessionStorage,
		}),
	],
});
